import { Reducer } from "redux"
import { config } from "bridger"
import * as Sentry from "@sentry/react"
import { EndpointsType, AuthUserType } from "../../Actions/Types"
import { UserAction } from "../Auth/UserReducer"

interface IEndpointsState {
    apiUrl: string
    throttle: string[]
    stripe: {
        publishableKey: string
    }
    contentful: {
        spaceID: string
        environment: string
        accessToken: string
    }
    cognito: {
        region: string
        userPoolId: string
        userPoolWebClientId: string
        oauth?: {
            domain: string
            scope: string[]
            responseType: string
            redirectSignIn: string
            redirectSignOut: string
        }
        passwordRequirementText?: string
        passwordRegex?: string
    }
    sentry: Sentry.BrowserOptions
}

export type EndpointsState = IEndpointsState

interface IEndpointsAction {
    type: EndpointsType
    payload?: string[]
}

export type EndpointsAction = IEndpointsAction

const initialState: EndpointsState = {
    ...config.dash,
    apiUrl: config.nacelle,
    throttle: []
}

export const EndpointsReducer: Reducer<
    EndpointsState,
    EndpointsAction | UserAction
> = (state = initialState, action): EndpointsState => {
    switch (action.type) {
        case EndpointsType.throttleFetch:
            return action.payload
                ? {
                      ...state,
                      throttle: action.payload
                  }
                : state
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
